<template>

  <div class="icon-container" >
    <!-- if watching, should be able to remove -->
    <div v-if="itemHasMeasures">
      <button v-if="areAllMeasuresInWatchList()"
              @click="removeProcedureFromWatch"
              class="icon__btn icon--minus">
        <span>Trend −
        </span>
      </button>
      <button  v-else-if="isProcedureInWatchList()"
              @click="removeProcedureFromWatch"
              class="icon__btn icon--purple">
        <span>Trend −
          <!-- <font-awesome-icon icon="minus-circle" class="mr-md-2 mr-2 icon--minus" /> -->
        </span>
      </button>

      <!-- else, should be able to add -->
      <button  v-else
              @click="addProcedureToWatch"
              class="icon__btn icon--plus">
        <span>Trend +
          <!-- <font-awesome-icon icon="plus-circle" class="mr-md-2 mr-2 icon--plus" /> -->
          </span>
      </button>
    </div>
    <div v-else>
      <button class="icon__btn" style="visibility: hidden">
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-md-2 mr-2 icon--plus fa-disabled"/>
      </button>
    </div>
  </div>

</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { hasMeasures } from '@/data/getters';
  import router from '@/router/index';
  import { WatchNavigation } from '@/store/modules/fsm/messages';

  export default {
    name: "watch-button-procedure",
    props: {
      procId: null,
      procIds: null,
      procCcd: null // aka cpt code
    },
    data() {
      return {
        isProcedureInWatchList: () => {
          return this.proceduresInWatchList.hasOwnProperty(this.procCcd);
        },
        areAllMeasuresInWatchList: () => {
          if (!this.procIds)
            return false
          let m = []
          let procmeas = this.allData.procmeas
          let measures = this.allData.measures
          this.procIds.forEach(procId => {
            let measIds = procmeas[procId]
            if (measIds) {
              measIds.forEach(measId => {
                let measCcd = measures[measId].ccd
                if (!m.includes(measCcd)){
                  m.push(measCcd)
                }
              })
            }
          })
          if (!this.proceduresInWatchList[this.procCcd]){
            return false
          }
          return m.length == Object.keys(this.proceduresInWatchList[this.procCcd]).length
        }
      }
    },
    computed: {
      itemHasMeasures() {
        // console.log(this.procIds, typeof this.procIds) //object
        // console.log(this.procCcd, typeof this.procCcd) //number (same)
        if(this.procId) {
          return hasMeasures(this.procId,this.allData);
        }
        else if(this.procIds) {
          for(let i = 0;i < this.procIds.length;i++) {
            if(hasMeasures(this.procIds[i],this.allData)) {
              return true;
            }
          }
        }
        return false;
      },
      ...mapGetters('login',{
        allData: 'getAllData'
      }),
      ...mapGetters('login/watch', {
        proceduresInWatchList: 'getProceduresWatching',
        checkedMeasures: 'getCheckedMeasures'
      }),
      
    },
    methods: {
      ...mapActions('login/watch', [
        'addProcedure',
        'removeProcedure',
        'removeMeasure',
        'removeCheckedMeasure'
      ]),
      addProcedureToWatch () {

        // this.addProcedure({
        //   proc: this.procId, 
        //   meas: this.allData.procmeas[this.procId]
        // });
        // use cpt code to find all of its meas' ccd
        router.push({name:WatchNavigation, params: {procCcd: this.procCcd}})
        this.addProcedure(this.procCcd);
      },

      async handleRemoveMeasure(procCcd, measCcd) {
        await this.removeCheckedMeasure(measCcd)
        await this.removeMeasure({proc: procCcd, meas: measCcd})
      },

      async removeProcedureFromWatch () {
        let procmeas = this.proceduresInWatchList[this.procCcd]
        await this.removeProcedure(this.procCcd);
        for (const [key, value] of Object.entries(procmeas)){
          await this.removeCheckedMeasure(key)
        }
        // await this.removeProcedure(this.procCcd);
        // console.log(this.procCcd)
        // if (this.newestProcedure.proc == this.procCcd){
        //   this.removeNewestProcedure()
        // }
      },
    }

  }
</script>

<style scoped lang="scss">
  $color-base: #0060ff;

  .icon-container {
    margin-left: auto;
    position: relative;
    float: right;
    // display: inline-block;
    .icon__btn {
      color: white;
      border-radius: 20px;
      border: none;
      padding-top: 2%;
      /*padding-bottom: 30%;*/
      font-size: 1.2rem;
    }

    .icon__btn--small {
      position: absolute;
      margin-left: -2.65rem;
      padding-top: 20%;
      background-color: transparent;
      font-size: 1.0rem;
    }

    .icon--plus {
      background-color: $color-base;
      &:hover {
        cursor: pointer;
        background-color: darken($color-base, 20%);
      }
    }

    .icon--minus {
      background-color: #ff4444;
      &:hover {
        cursor: pointer;
        background-color: #cc0000;
      }
    }

    .icon--purple {
      background-color: #8052a2;
      &:hover {
        cursor: pointer;
        background-color: darken(#8052a2, 20%)
      }
    }

  }
</style>
